export const BORDER_RADIUS = '24px';
export const PADDING = '24px';
